// User.jsx
import React, { useEffect, useState } from "react";
import { Link, withRouter } from "react-router-dom";
import { UserCard } from "./UserCard";
import { Col, Row, Spinner, Form } from "react-bootstrap";
import "./User.scss";
import { DeleteModal } from "../Modals/DeleteModal";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteUser,
  setCurrentUserData,
  userList,
} from "../../../redux/actions/dbactions/profileActions";
import { Header } from "../../Header";
import { Icon } from "@iconify/react/dist/iconify.js";

const User = ({ searchQuery }) => {
  const dispatch = useDispatch();
  const { user, isLoading } = useSelector((state) => state.user || {});

  const [show, setShow] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [selectedTitle, setSelectedTitle] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const [selectedCountryId, setSelectedCountryId] = useState(null);

  const [searchEmail, setSearchEmail] = useState("");

  useEffect(() => {
    dispatch(userList());
  }, [dispatch, refresh]);

  const handleShow = (id, firstName, lastName) => {
    setShow(true);
    setSelectedId(id);
    setSelectedTitle(`${firstName} ${lastName}`);
  };

  const handleEditModal = (data) => {
    setEditModal(true);
    dispatch(setCurrentUserData(data));
    setSelectedCountryId(data.addr_country_id);
  };

  const handleDelete = () => {
    dispatch(deleteUser(selectedId));
    setRefresh(!refresh);
    setShow(false);
  };

  // Filter users by email based on search input
  const filteredUsers = user?.usr?.filter((item) =>
    item.user_email.toLowerCase().includes(searchEmail.toLowerCase())
  );
  return (
    <div>
      <Header pageTitle="User List" icon={<Icon icon="fa-solid:user" />} />
      <div className="ser_title_b sm:!px-8 !px-3 mt-4 xs:!flex-row flex-col">
        <h5 className="title">My User List</h5>

      </div>

      {/* Search Bar */}
      <div className="search-bar-container mt-3 mb-3">
        <Form.Control
          type="text"
          placeholder="Search by email..."
          value={searchEmail}
          onChange={(e) => setSearchEmail(e.target.value)}
          className="search-bar"
        />
      </div>

      {isLoading ? (
        <div className="text-center">
          <Spinner animation="border" variant="primary" />
        </div>
      ) : (
        <Row className="sm:px-4 m-0">
          {filteredUsers && filteredUsers.length > 0 ? (
            filteredUsers.map((item) => (
              <Col className="mb-3" lg={4} md={6} key={item.user_id}>
                <UserCard
                  data={item}
                  searchQuery={searchQuery}
                  handleShow={() => handleShow(item.user_id, item.user_first_name, item.user_last_name)}
                  handleEditModal={() => handleEditModal(item)}
                />
              </Col>
            ))
          ) : (
            <Col>
              <p className="text-center">No users found</p>
            </Col>
          )}
        </Row>
      )}
      <DeleteModal
        handleDelete={handleDelete}
        show={show}
        handleClose={() => setShow(false)}
        selectedTitle={selectedTitle}
      />
    </div>
  );
};

export default withRouter(User);
